<div class="main-card mb-3 card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="font-weight-bold fs-1r">Tyres</span>
    <button class="btn btn-primary" (click)="openAddTyre()">+ Add Tyres</button>
  </div>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th>Id</th>
          <th>No of Tyres</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of allTyres">
          <td>{{ data._id }}</td>
          <td>{{ data.tyreType }}</td>
          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                Action
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="openEditTyre(data)">
                    Edit <i class="fa fa-pencil"></i>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="deleteTyre(data._id)">
                    Delete <i class="fa fa-pencil"></i>
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="allTyres?.length === 0" class="text-center mt-5 mb-5">
      <span class="text-danger">Data Not Found</span>
    </div>
  </div>
</div>

<!-- Child modal -->
<app-add-edit-tyre
  [tyreData]="selectedTyre"
  [showModal]="showTyreModal"
  (refreshTyres)="getAllTruckTyres()"
  (closeModal)="handleCloseModal()"
></app-add-edit-tyre>
